// extracted by mini-css-extract-plugin
export default {"screenReaderOnly":"br_zMs"};